<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.displayStatus"
        placeholder="全部状态"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          v-for="(item, i) in displayData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item style="margin-left:22px;">
      <el-input
        clearable
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="评论内容|资源名称|评论人"
      ></el-input>
    </el-form-item>
    <el-form-item style="margin-right: 0px;">
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import { getDataMap } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn
  },
  data() {
    return {
      size: "small",
      filters: {},
      displayData: []
    };
  },
  created() {
    getDataMap("DISPLAY_STATUS").then(res => {
      if (!res || res.code != 0) return;
      this.displayData = res.data;
    });

    Bus.$on("bizType", item => {
      this.filters.bizType = item;
      this.$emit("search", this.filters);
    });
  },
  methods: {
    initData() {
      //查询
      this.$emit("search", this.filters);
    },
    resetData() {
      //重置
      this.filters = { bizType: this.filters.bizType };
      this.$emit("search", this.filters);
    }
  }
};
</script>
